// extracted by mini-css-extract-plugin
module.exports = {"wordTile":"WordTile_wordTile__Bs2QE","wordTileClickable":"WordTile_wordTileClickable__rjRoC","text":"WordTile_text__1VrRV","circle":"WordTile_circle__1whdr"};